import type { AppRouter } from 'codesearch-backend'
import { createTRPCClient, createWSClient, loggerLink, wsLink } from '@trpc/client'
import SuperJSON from 'superjson'

const debugEnabled = new URLSearchParams(location.search).get('debug') === '1'

export const trpc = createTRPCClient<AppRouter>({
  links: [
    loggerLink({ enabled: () => debugEnabled }),
    wsLink({
      client: createWSClient({ url: `${location.origin.replace(/^http/, 'ws')}/api/ws` }),
      transformer: SuperJSON,
    }),
  ],
})
